import NextImage from "@/components/NextImage";

// Lazy + display:none means each viewport downloads only its own image.
const VIEWPORT_CLASS = {
  desktop: "hidden min-[992px]:block",
  mobile: "min-[992px]:hidden",
};

// Always the full strip width at the image's own ratio, pinned to the top: a taller image loses
// its bottom, never its sides; a flatter one leaves the background colour showing underneath.
// width/height 0 + sizes lets next/image size the image from CSS instead of fixed dimensions;
// !max-h-none lifts the global `img { max-height: 100% !important }` that would squash it to 48 px.
export default function BannerBackground({ images }) {
  return Object.entries(VIEWPORT_CLASS).map(([viewport, className]) =>
    images[viewport] ? (
      <div key={viewport} className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
        <NextImage src={images[viewport]} alt="" width={0} height={0} sizes="100vw" className="absolute inset-x-0 top-0 h-auto !max-h-none w-full" />
      </div>
    ) : null
  );
}
